// create a container and set the full-size image as its background
function createOverlay(image, event, zoomRatio) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
    // Focus the zoom on wherever the customer actually tapped/clicked,
    // instead of defaulting to the top-left corner until they move.
    moveWithHover(image, overlay, event, zoomRatio);
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.touchAction = 'none';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

// Works for both mouse events and touch events (touch events keep their
// coordinates inside `touches`/`changedTouches` instead of directly on
// the event).
function getPointerPosition(event) {
  if (event.touches && event.touches.length) return event.touches[0];
  if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0];
  return event;
}

function moveWithHover(image, overlay, event, zoomRatio) {
  // calculate mouse/tap position relative to the image itself (not
  // whatever element happened to receive this particular event, since
  // that can be the image, the toggle button, or the overlay depending
  // on which tap this is)
  const pointer = getPointerPosition(event);
  const ratio = image.height / image.width;
  const container = image.getBoundingClientRect();
  const xPosition = pointer.clientX - container.left;
  const yPosition = pointer.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

// Returns true if an overlay was found and closed, false if there
// wasn't one open to begin with.
function closeOverlay(image) {
  const existing = image.parentElement.querySelector('.image-magnify-full-size');
  if (!existing) return false;
  existing.remove();
  image.style.opacity = '100%';
  return true;
}

function magnify(image, event, zoomRatio) {
  const overlay = createOverlay(image, event, zoomRatio);

  // Desktop: pan by moving the mouse, close on click or when the
  // cursor leaves the image.
  overlay.onclick = () => closeOverlay(image);
  overlay.onmousemove = (e) => moveWithHover(image, overlay, e, zoomRatio);
  overlay.onmouseleave = () => closeOverlay(image);

  // Mobile: pan by dragging a finger across the zoomed image. Track
  // whether the touch actually moved so a drag-and-release doesn't
  // also get treated as a tap that closes the overlay.
  let dragged = false;
  let startX = 0;
  let startY = 0;

  overlay.addEventListener(
    'touchstart',
    (e) => {
      const pointer = getPointerPosition(e);
      startX = pointer.clientX;
      startY = pointer.clientY;
      dragged = false;
    },
    { passive: true }
  );

  overlay.addEventListener(
    'touchmove',
    (e) => {
      // Stop the page itself from scrolling while panning the zoomed image.
      e.preventDefault();
      const pointer = getPointerPosition(e);
      if (Math.abs(pointer.clientX - startX) > 5 || Math.abs(pointer.clientY - startY) > 5) {
        dragged = true;
      }
      moveWithHover(image, overlay, e, zoomRatio);
    },
    { passive: false }
  );

  overlay.addEventListener(
    'touchend',
    () => {
      if (!dragged) closeOverlay(image);
    },
    { passive: true }
  );
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    // The visible click target is actually the modal-opener's toggle
    // button, which sits on top of the image to open Dawn's native
    // modal. Bind there (and directly on the image, so tapping any
    // part of the picture works, not just the small icon), in the
    // capture phase, so our handler runs before that modal-opening
    // listener and can cancel it.
    const opener = image.closest('modal-opener');
    const button = opener && opener.querySelector('.product__media-toggle');
    const triggers = button ? [button, image] : [image];

    triggers.forEach((trigger) => {
      trigger.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          // Toggle: if it's already zoomed in, this tap zooms back out
          // instead of stacking another zoomed overlay on top.
          if (closeOverlay(image)) return;

          magnify(image, event, zoomRatio);
        },
        true
      );
    });
  });
}

enableZoomOnHover(1.6);